import { withRelativePointer, withMountOnMediaQuery } from '@studiometa/js-toolkit';
import { Cursor } from '@studiometa/ui';
import type { BaseProps } from '@studiometa/js-toolkit';

export interface RelativeCursorProps extends BaseProps {
  $options: {
    growSelectors: string[];
    shrinkSelectors: string[];
    growTo: number;
    shrinkTo: number;
    scale: number;
  };
}

/**
 * RelativeCursor
 */
export default class RelativeCursor extends withMountOnMediaQuery(
  withRelativePointer(Cursor, {
    target: (instance) => instance.$el.parentNode as HTMLElement,
  }),
  'not (pointer: coarse)',
)<RelativeCursorProps> {
  static config = {
    ...Cursor.config,
    name: 'RelativeCursor',
  };

  pointerScale: number;
  pointerX: number;
  pointerY: number;

  /**
   * Moved relative hook.
   * @param {object} props
   * @param {Event} props.event
   * @param {number} props.x
   * @param {number} props.y
   * @param {boolean} props.isDown
   */
  movedrelative({ event, x, y, isDown }) {
    if (!this.$services.has('ticked')) {
      this.$services.enable('ticked');
    }

    this.pointerX = x;
    this.pointerY = y;

    let { scale } = this.$options;

    if (!event) {
      this.pointerScale = scale;
      return;
    }

    const shouldGrow =
      (event.target instanceof Element && event.target.matches(this.$options.growSelectors)) ||
      false;
    const shouldReduce =
      isDown ||
      (event.target instanceof Element && event.target.matches(this.$options.shrinkSelectors)) ||
      false;

    if (shouldGrow) {
      scale = this.$options.growTo;
    }

    if (shouldReduce) {
      scale = this.$options.shrinkTo;
    }

    this.pointerScale = scale;
  }

  /**
   *
   */
  moved() {
    // silence is golden
  }
}
